import React from 'react';
import Slider from 'react-slick';
import {TitleWrap, SecSubTitle, SecTitle, TeamBoxTwo} from '../../components';


const TeamTwo = ({...restProps})=> {     

  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };  
  
  return (
    <div {...restProps}>
      <div className="container">
        <TitleWrap className="text-center">
          <SecSubTitle>GREAT TEAM MEMBERS</SecSubTitle>
          <SecTitle className="h1 text-capitalize">We Have Expert Team</SecTitle>
        </TitleWrap>
        <Slider {...settings}>
          <TeamBoxTwo
            name="Adekunle James Adeniji"
            desgination="CEO/Software Engineer"
            image="images/team/james-min.png"
          />
          <TeamBoxTwo
            name="Abraham Akintola"
            desgination="CO-CEO/Software Engineer"
            image="images/team/abraham-min.png"
            path="/team-details"
          />
          <TeamBoxTwo
            name="Daniel Olaseinde"
            desgination="UI/UX Designer"
            image="images/team/daniel2.png"
            path="/team-details"
          />
          <TeamBoxTwo
            name="Olamiposi Ajisafe"
            desgination="Business Development"
            image="images/team/olamiposi5.png"
            path="/team-details"
          />
        </Slider>
      </div>
    </div>
  );
}

export default TeamTwo;